(()=>{
  'use strict';
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
  const wait=$('#waitlist');

  $$('.js-waitlist').forEach(b=>b.addEventListener('click',()=>{
    wait?.scrollIntoView({behavior:'smooth',block:'center'});
    setTimeout(()=>$('.wait-input input',wait)?.focus?.(),550);
  }));

  const io=('IntersectionObserver' in window)
    ? new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('visible');io.unobserve(e.target)}}),{threshold:.08,rootMargin:'0px 0px -7%'})
    : null;
  if(io) $$('.reveal').forEach(el=>io.observe(el)); else $$('.reveal').forEach(el=>el.classList.add('visible'));

  const sticky=$('.sticky-wait');
  const updateSticky=()=>{
    if(!sticky) return;
    const on=innerWidth<760 && scrollY>680 && scrollY<document.documentElement.scrollHeight-innerHeight-300;
    sticky.classList.toggle('show',on);
  };
  addEventListener('scroll',updateSticky,{passive:true}); addEventListener('resize',updateSticky); updateSticky();

  /*
    V6 FORM BRIDGE
    ----------------
    Keep ORIGYN's custom form visible. Shopify Forms remains mounted off-screen and
    is used only as the real submission engine. This version deliberately mirrors
    the previously working ORIGYN V12 bridge and adds retries for Shopify's phone
    web-component state so a visual value cannot be mistaken for an empty phone.
  */
  const proxy=$('.wait-proxy-form');
  const nameInput=proxy?.querySelector('input[type="text"]');
  const phoneInput=proxy?.querySelector('input[type="tel"]');
  const btn=$('.wait-submit');
  const err=$('.wait-error');
  const success=$('.wait-success');
  const engine=$('.shopify-form-engine');

  function getEmbed(){
    return engine?.querySelector('shopify-forms-embed') || document.querySelector('.shopify-form-engine shopify-forms-embed');
  }
  function getRoot(){
    const embed=getEmbed();
    return embed?.shadowRoot || null;
  }
  function meta(el,root){
    if(!el) return '';
    let t=((el.name||'')+' '+(el.id||'')+' '+(el.autocomplete||'')+' '+(el.placeholder||'')+' '+(el.getAttribute?.('aria-label')||'')).toLowerCase();
    if(el.id){
      try{ t+=' '+(root?.querySelector(`label[for="${CSS.escape(el.id)}"]`)?.textContent||'').toLowerCase(); }catch(_){}
    }
    t+=' '+(el.closest?.('label')?.textContent||'').toLowerCase();
    return t.replace(/\s+/g,' ').trim();
  }
  function getForm(root){ return root?.querySelector('form') || null; }
  function phoneCandidates(root){
    if(!root) return [];
    const inputs=[...root.querySelectorAll('input')];
    const scored=[];
    for(const i of inputs){
      const m=meta(i,root);
      let score=0;
      if(i.type==='tel') score+=100;
      if(/phone|mobile|telephone|tel\b/.test(m)) score+=70;
      if(/phone/.test(i.name||'')) score+=50;
      if(/one-time-code|search/.test(i.autocomplete||'')) score-=100;
      if(i.type==='hidden') score-=80;
      if(score>0) scored.push([score,i]);
    }
    return scored.sort((a,b)=>b[0]-a[0]).map(x=>x[1]);
  }
  function getPhone(root){ return phoneCandidates(root)[0] || null; }
  function getName(root){
    if(!root) return null;
    const inputs=[...root.querySelectorAll('input')].filter(i=>i.type!=='tel'&&i.type!=='email'&&i.type!=='hidden');
    return inputs.find(i=>/first\s*name|given\s*name/.test(meta(i,root))) ||
           inputs.find(i=>/\bname\b/.test(meta(i,root))) ||
           inputs.find(i=>i.type==='text') || null;
  }
  function getSubmit(root,form){
    if(!root) return null;
    const candidates=[...root.querySelectorAll('button,input[type="submit"]')];
    return candidates.find(b=>b.matches?.('button[type="submit"],input[type="submit"]')) ||
           candidates.find(b=>/submit|sign up|subscribe|join|send/i.test((b.textContent||b.value||'').trim())) ||
           form?.querySelector('button[type="submit"],input[type="submit"]') || null;
  }
  function nativeSet(input,value){
    if(!input) return;
    try{ input.focus?.(); }catch(_){}
    const desc=Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value');
    if(desc?.set) desc.set.call(input,value); else input.value=value;
    input.setAttribute('value',value);
    input.dispatchEvent(new InputEvent('input',{bubbles:true,composed:true,data:value,inputType:'insertText'}));
    input.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
    input.dispatchEvent(new KeyboardEvent('keyup',{bubbles:true,composed:true,key:'0'}));
    input.dispatchEvent(new Event('blur',{bubbles:true,composed:true}));
  }
  function hydratePhone(root,value){
    const candidates=phoneCandidates(root);
    candidates.forEach((input,idx)=>nativeSet(input,value));
    const main=candidates[0];
    if(main){
      let node=main.parentElement;
      for(let i=0;node && i<5;i++,node=node.parentElement){
        if(node.tagName?.includes('-')){
          try{ if('value' in node) node.value=value; }catch(_){}
          node.dispatchEvent(new Event('input',{bubbles:true,composed:true}));
          node.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
        }
      }
    }
    return main;
  }
  function resetButton(){
    if(!btn) return;
    btn.disabled=false;
    btn.innerHTML='JOIN THE WAITLIST <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h14M14 7l5 5-5 5"/></svg>';
  }
  function showError(message){
    if(err){err.textContent=message||'Something went wrong. Please try again.';err.hidden=false;}
    resetButton();
  }
  function showSuccess(){
    if(proxy) proxy.hidden=true;
    if(success) success.hidden=false;
    resetButton();
  }
  function currentError(root){
    const nodes=[...root.querySelectorAll('[class*="error" i],[role="alert"],[aria-invalid="true"]')];
    return nodes.map(n=>(n.textContent||'').replace(/\s+/g,' ').trim()).filter(Boolean).join(' | ');
  }
  function successDetected(root){
    const txt=(root?.textContent||'').toLowerCase();
    return !root?.querySelector('form') || !!root?.querySelector('[class*="success" i],[data-testid*="success" i]') ||
      txt.includes('thank you') || txt.includes('successfully') || txt.includes('signed up') || txt.includes("you're in");
  }
  function submitActual(root){
    const form=getForm(root), submit=getSubmit(root,form);
    if(!form || !submit) return false;
    try{ submit.click(); return true; }catch(_){}
    try{ form.requestSubmit?.(submit); return true; }catch(_){}
    return false;
  }
  function waitForOutcome(root,phoneLocal,attemptNo=0){
    let ticks=0;
    const timer=setInterval(()=>{
      ticks++;
      if(successDetected(root)){
        clearInterval(timer); showSuccess(); return;
      }
      const e=currentError(root);
      if(e){
        // Shopify sometimes validates its phone web-component before its state catches up.
        // Retry silently with E.164 once, then with 91-prefixed digits once.
        if(/phone.*required|required.*phone/i.test(e) && attemptNo<2){
          clearInterval(timer);
          const next=attemptNo===0 ? `+91${phoneLocal}` : `91${phoneLocal}`;
          const phone=hydratePhone(root,next);
          setTimeout(()=>{
            phone?.dispatchEvent(new Event('change',{bubbles:true,composed:true}));
            submitActual(root);
            waitForOutcome(root,phoneLocal,attemptNo+1);
          },350);
          return;
        }
        if(ticks>3){
          clearInterval(timer);
          // Do not leak Shopify's internal validation wording unless it helps the user.
          if(/phone.*required|required.*phone/i.test(e)) showError('Please re-enter your mobile number and try once more.');
          else showError('Something went wrong. Please try again in a moment.');
          return;
        }
      }
      if(ticks>50){ clearInterval(timer); showError('Something went wrong. Please try again in a moment.'); }
    },250);
  }

  proxy?.addEventListener('submit',e=>{
    e.preventDefault(); if(err) err.hidden=true;
    const customerName=(nameInput?.value||'').trim().replace(/\s+/g,' ');
    const phoneLocal=(phoneInput?.value||'').replace(/\D/g,'').replace(/^91(?=\d{10}$)/,'');
    if(customerName.length<2){showError('Please enter your name.');nameInput?.focus();return;}
    if(phoneLocal.length!==10){showError('Please enter a valid 10-digit mobile number.');phoneInput?.focus();return;}

    btn.disabled=true; btn.textContent='JOINING WAITLIST…';
    let tries=0;
    const connect=()=>{
      const root=getRoot();
      if(!root){ if(tries++<40){setTimeout(connect,200);return;} showError('Something went wrong. Please refresh and try again.'); return; }
      const firstName=getName(root), phone=getPhone(root), form=getForm(root), submit=getSubmit(root,form);
      if((!firstName||!phone||!form||!submit) && tries++<40){setTimeout(connect,200);return;}
      if(!firstName||!phone||!form||!submit){showError('Something went wrong. Please refresh and try again.');return;}

      nativeSet(firstName,customerName);
      hydratePhone(root,phoneLocal);

      // Let Shopify's web-component state settle before submitting.
      setTimeout(()=>{
        if(!submitActual(root)){showError('Something went wrong. Please try again in a moment.');return;}
        waitForOutcome(root,phoneLocal,0);
      },450);
    };
    connect();
  });
})();
